angular.module('zc.projects')

.directive 'zcCampaignControlPercentLabels', (CampaignStats, Devise) ->
  restrict: 'E'
  scope: {
    campaign: '<'
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_control_percent_labels.html'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_control_percent_labels.js.coffee